/**
 * La foto de portada de cada inmueble, por su id.
 *
 * Sale del listado de Propiedades, que ya trae la portada firmada de cada uno: así las tarjetas
 * de Ingresos y gastos y de Suministros la enseñan sin tocar sus propias respuestas, y comparten
 * caché con la pantalla de Propiedades (la misma consulta).
 */
import { useQuery } from '@tanstack/react-query';
import { api, queryKeys } from '../api/client';

export interface PropertyCover {
  url: string | null;
  placeholderColor: string | null;
}

const PARAMS = { limit: 200 } as const;

export function usePropertyCovers(): Map<string, PropertyCover> {
  const { data } = useQuery({
    queryKey: queryKeys.properties(PARAMS),
    queryFn: () => api.properties(PARAMS),
    // Las URL firmadas caducan; cinco minutos de margen sobra para una tarjeta.
    staleTime: 5 * 60_000,
  });
  const covers = new Map<string, PropertyCover>();
  for (const group of data?.groups ?? []) {
    for (const property of group.properties) {
      if (property.cover) covers.set(property.id, { url: property.cover.url, placeholderColor: property.cover.placeholderColor });
    }
  }
  return covers;
}
